import store from '../store/Store';

export function getEnabledFlights(sourceId?: string): string[] {
    const featureFlags = store(sourceId).featureFlags;
    return [...featureFlags.keys()];
}
